/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_NoticeInputs */

const en_landing_hero_notice = /** @type {(inputs: Landing_Hero_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strictly prohibits adult / NSFW content`)
};

const zh_landing_hero_notice = /** @type {(inputs: Landing_Hero_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`严禁成人 / NSFW 内容`)
};

/**
* | output |
* | --- |
* | "Strictly prohibits adult / NSFW content" |
*
* @param {Landing_Hero_NoticeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_hero_notice = /** @type {((inputs?: Landing_Hero_NoticeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_NoticeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_hero_notice(inputs)
	return zh_landing_hero_notice(inputs)
});
export { landing_hero_notice as "landing.hero.notice" }